//@ts-nocheck
//@ts-nocheck
import { Flex, Stack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRequestFlowStore } from "../stores";
import JobSummary from "../tutor-revamp/JobSummary";
import BookingCard from "./BookingCard";
import EmptyJobList from "./EmptyJobList";

type Props = {
  bookings: Array<IRequestFlowStore>;
  onOpenModal: (action: string, requestSlug: string) => void;
  onNavigate: (requestSlug: string) => void;
  onSetSchedule: any;
  tutorInfo: any;
  host: string;
  agent: any;
  asSummary: boolean;
  [key: string]: any;
};

const BookingLists = observer(
  ({
    bookings = [],
    onOpenModal,
    onSetSchedule = () => {},
    tutorInfo = {},
    host,
    agent,
    asSummary,
    onNavigate,
    ...rest
  }: Props) => {
    if (!bookings.length) return <EmptyJobList />;

    return (
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="stretch"
        width="100%"
        pb={[6, 8]}
        {...rest}
      >
        <Stack spacing={[5, 6]} width="100%">
          {bookings.map((request) => {
            let booking = request.jobInfo;
            return asSummary ? (
              <JobSummary
                {...booking}
                store={request.serverInfo}
                key={booking.requestSLUG}
                tutorInfo={tutorInfo}
                onSetSchedule={onSetSchedule}
                onClick={() => {
                  onNavigate(booking.requestSLUG);
                }}
                host={host}
              />
            ) : (
              <BookingCard
                {...booking}
                store={request.serverInfo}
                key={booking.requestSLUG}
                tutorInfo={tutorInfo}
                onSetSchedule={onSetSchedule}
                openModal={(action: string) => {
                  onOpenModal(action, booking.requestSLUG);
                }}
                workingAgent={agent}
                host={host}
              />
            );
          })}
        </Stack>
      </Flex>
    );
  },
);

export default BookingLists;
